import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { activateNavigator, deactivateNavigator, setNavigator } from '../../submodules/shared/utils/navigator';

// Wires react-router-dom v7's `useNavigate()` into the module-level
// navigator callable. Must be mounted as a child of `<BrowserRouter>`.
//
// - `setNavigator` runs in the render body so the callback is present for
//   any render-phase caller (e.g. a class constructor that dispatches an
//   action which calls `navigate(...)`).
// - `activateNavigator` runs in a commit-phase effect so RR's internal
//   activeRef has flipped before the first navigation fires.
// - `deactivateNavigator` clears ALL module state on unmount so
//   post-unmount calls throw rather than queuing against a future remount.
// - Empty deps array: re-running activation on every URL change would
//   wipe state mid-flight because `useNavigate()` returns a new memo
//   identity per location.

const NavigatorBridge = () => {
    setNavigator(useNavigate());

    useEffect(() => {
        activateNavigator();
        return deactivateNavigator;
    }, []);

    return null;
};

export default NavigatorBridge;
